// src/helpers/usePersistedState.svelte.ts
/**
 * Reactive state backed by localStorage. Reading `.value` returns the current
 * state; assigning `.value` both updates the reactive state and persists to
 * localStorage (or removes the key when assigned `undefined` or `null`).
 *
 * Must be called during Svelte component initialisation (i.e. inside a factory
 * function that is called from a component's <script> block).
 */
export function usePersistedState(key, fallback) {
    const raw = localStorage.getItem(key);
    let value = $state(raw !== null ? JSON.parse(raw) : fallback);
    return {
        get value() {
            return value;
        },
        set value(v) {
            value = v;
            if (v === undefined || v === null) {
                localStorage.removeItem(key);
            }
            else {
                localStorage.setItem(key, JSON.stringify(v));
            }
        },
    };
}
